var React = require('react');

function Wind (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #13130a;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("path",{"className":"cls-1","d":"M.64,10.28c28.9-29.5,36.38,22.77,66.94-6.96","key":0}),React.createElement("path",{"className":"cls-1","d":"M.71,23.81c28.9-29.5,36.38,22.77,66.94-6.96","key":1}),React.createElement("path",{"className":"cls-1","d":"M.77,37.35c28.9-29.5,36.38,22.77,66.94-6.96","key":2}),React.createElement("path",{"className":"cls-1","d":"M.84,50.89c28.9-29.5,36.38,22.77,66.94-6.96","key":3})])]);
}

Wind.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 68.41 54.34"};

module.exports = Wind;

Wind.default = Wind;
